import { render, staticRenderFns } from "./BoxDetail.vue?vue&type=template&id=7efe32f8&scoped=true&"
import script from "./BoxDetail.vue?vue&type=script&lang=js&"
export * from "./BoxDetail.vue?vue&type=script&lang=js&"
import style0 from "./BoxDetail.vue?vue&type=style&index=0&id=7efe32f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efe32f8",
  null
  
)

export default component.exports